<template>
<div class="card">
	<div class="dash-card-header "> 
		<div class="back-link pl-2">
			<button v-if="update" @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg" >
			</button>
		</div>
		<div class="title-div font-medium font-size-15"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("address")}}</div>
		<div class="logout-link ">
			<img class="" src="@/assets/logout.svg" @click="logout">
		</div>
	</div>	
      <div class="justify-center items-center color-custom pt-12">
        <div class="pb-20 col-sm-12">
				<div v-if="update" class="form-group col-sm-12">
					<input type="text" class="form-control bg-color-grblue-border" ref="name" :placeholder='$t("fname")' v-model="form.name" required>
				</div>
				<div v-if="update" class="form-group col-sm-12">
					<input type="text" class="form-control bg-color-grblue-border" ref="surname"  :placeholder='$t("lastname")' v-model="form.lastname" required>
				</div>
				<div v-if="update" class="form-group col-sm-12">
					<input type="text" v-on:keypress="checkNumOnly($event)" class="form-control bg-color-grblue-border" ref="phone" :placeholder='$t("phone")' v-model="form.phone" required>
				</div>
				<div class="row ml-1 mr-1">
					<div class="form-group col-sm-12">
						<input type="text" class="form-control bg-color-grblue-border" ref="street" :placeholder='$t("address1")' v-model="form.street" >
					</div>
					<div class="form-group col-sm-6">
						<input type="text" class="form-control bg-color-grblue-border" ref="number"  :placeholder='$t("number")' v-model="form.number">
					</div>
					<div class="form-group col-sm-6">
						<input type="text" class="form-control bg-color-grblue-border" ref="box" :placeholder='$t("door")' v-model="form.box" >
					</div>
				</div>
				<div class="form-group col-sm-12">
					<input type="number" class="form-control bg-color-grblue-border" ref="zip" :placeholder='$t("zip")' v-model="form.zip" >
				</div>
				<div class="form-group col-sm-12">
					<input class="form-control bg-color-grblue-border" :placeholder='$t("city")' type="text" v-model="form.city" ref="city" >
				</div>
				<div class="form-group col-sm-12">
					<select v-if="countries.length > 1" class="form-select form-select-lg col-sm-12 pull-right bg-color-grblue-border" v-model="form.country" ref="country">
						<option  value="">{{$t("country")}}</option>
						<option v-for="(item) in countries" :key="item.id" :value="item.country_code" >{{item.name}}</option>
					</select>
					<div v-else >
						<input v-model="form.country" type="hidden" v-for="(item) in countries" :key="item.id" />
					</div>
				</div>
				<div v-if="errorMsg" class="form-group col-sm-12 text-center">
					<div class=" p-4 btn-danger">{{errorMsg}}</div>
				</div>
				<br>
			<div v-if="update" class="form-group col-sm-12 mt-5">
				<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("next")}}</button>
			</div>
			<div v-else class="form-group col-sm-12 mt-5">
				<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("next")}}</button>
			</div>
        </div> 
    </div>
</div>

</template>
<script>
import repository from "@/api/repository";

export default {
	props: ['update'],
    data(){
        return{
            form:{
                street: '',
                box: '',
                number:'',
                zip:'',
                city:'',
                country: '',
                locale: localStorage.getItem('locale') || 'en-en',
				ukey:'',
				name: '',
                phone:  '',
                lastname: ''
            },
            error: 0,
            errorMsg: '',
			countries: [],
			loading: false,
			nextStepCheck: false
			
        }
    },
	async mounted() {		
		window.scrollTo(0,0)	
		let user = JSON.parse(localStorage.getItem('user'))
		
		if (user) {
			this.form.street = user.street
			this.form.ukey = user.ukey
			this.form.box = user.box
			this.form.number = user.number
			this.form.zip = user.zip
			this.form.city = user.city
			
			if (this.update) {
				this.form.country = user.country
			}
			if(user.name) {
				this.form.name = user.name
			}
			if(user.phone) {
				this.form.phone = user.phone
			}
			if(user.surname) {
				this.form.lastname = user.surname
			}

			if (user.worktype.length == 0) {  
				this.nextStepCheck = true;
			}
			
		}
		try {
			let { data } = await repository.getCountries();
			this.countries = data;
			if (this.countries.length == 1) {
				this.form.country = this.countries[0].country_code
			}
		} catch(error) {
			this.error = error
		}
	},
    methods:{
      hasHistory () { return window.history.length > 2 },
      async saveForm(){
		 this.$refs.street.classList.remove('bg-color-red-border')
		 this.$refs.number.classList.remove('bg-color-red-border')
		 this.$refs.zip.classList.remove('bg-color-red-border')
		 this.$refs.city.classList.remove('bg-color-red-border')
		 if (this.countries.length > 1) {
		 	this.$refs.country.classList.remove('bg-color-red-border')
		 }

          this.error = 0;
          this.loading = true;
          if (!this.form.street) {
              this.error++
              this.$refs.street.classList.add('bg-color-red-border')
          }
          if (!this.form.number) {
              this.error++
              this.$refs.number.classList.add('bg-color-red-border')
          }

          if (!this.form.zip) {
              this.error++
              this.$refs.zip.classList.add('bg-color-red-border')
          }
          if (!this.form.city) {
              this.error++
              this.$refs.city.classList.add('bg-color-red-border')
          }
          if (!this.form.country || this.form.country == 'Country') {
              this.error++
              this.$refs.country.classList.add('bg-color-red-border')
          }
	
          if(this.error > 0) {
              this.errorMsg = this.$t("perd")
			   this.loading = false;
              return;
          }

          try {
              let res = await this.$store.dispatch('registerAddress', this.form);

              if (!res.success) {
                  this.errorMsg = res.message
                  setTimeout(async () => {
                      await this.$router.push({ name: 'home' });
                  }, 3500)
                  return;
              }
			
			if(this.update && !this.nextStepCheck) {
				await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')}});
				return;
			}
              await this.$router.push({ name: 'registerContract', params: {lang: localStorage.getItem('locale')}});
          } catch (error) {
				if(error.response && error.response.data && error.response.data.message) {
					this.errorMsg = error.response.data.message;
				}
          }
   },
		  async logout(){
          this.error = null;
          try {
              await this.$store.dispatch('logout');
              await this.$router.push({ name: 'home', params: {lang: localStorage.getItem('locale')} });
          } catch (error) {
              this.errorMsg = error;
          } finally {
              this.loading = false;
          }
      },
		checkNumOnly(e) {
			let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) return true;
            else e.preventDefault();
		}
    }
}
</script>

<style scoped>
.color-custom {
	color: whitesmoke;
}
</style>